export default {

  acceptedMime: ["text/csv", "application/csv", "text/comma-separated-values",
    "application/comma-separated-values", "text/tsv", "application/tsv", "text/tab-separated-values",
    "text/application-separated-values"
  ],
  acceptedExtensions: ['tsv', 'csv']

}



// WEBPACK FOOTER //
// ./src/config/files.js